import { Component, inject, effect, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, NavbarComponent, FooterComponent, ToastComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  showNavbarFooter: boolean;
  private authService = inject(AuthService);
  private renderer = inject(Renderer2);

  constructor(private router: Router) {
    // Inicializar com o valor correto baseado na URL atual
    this.showNavbarFooter = this.shouldShowNavbar(this.router.url);
    this.updateBodyClass(this.router.url);

    // Esconder navbar/footer nas rotas de dashboard e auth
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const url = event.urlAfterRedirects || event.url;
        this.showNavbarFooter = this.shouldShowNavbar(url);
        this.updateBodyClass(url);
      });

    // Reagir a mudanças no estado de autenticação
    effect(() => {
      const user = this.authService.currentUser();
      this.showNavbarFooter = this.shouldShowNavbar(this.router.url);
      this.updateBodyClass(this.router.url);
    });
  }

  private shouldShowNavbar(url: string): boolean {
    const isDashboardRoute = url.startsWith('/paciente') || 
                            url.startsWith('/farmacia') || 
                            url.startsWith('/clinica') || 
                            url.startsWith('/deposito') || 
                            url.startsWith('/profissional') || 
                            url.startsWith('/admin');
    const isAuthRoute = url.startsWith('/login') || 
                        url.startsWith('/registro') || 
                        url.startsWith('/recuperar-senha');
    
    // Esconder navbar/footer se:
    // 1. Estiver em rotas de dashboard (/paciente, /farmacia, /clinica, /deposito, /profissional ou /admin)
    // 2. Estiver em rotas de autenticação (login, registro, recuperar-senha)
    return !isDashboardRoute && !isAuthRoute;
  }

  private updateBodyClass(url: string): void {
    const isDashboardRoute = url.startsWith('/paciente') || 
                            url.startsWith('/farmacia') || 
                            url.startsWith('/clinica') || 
                            url.startsWith('/deposito') || 
                            url.startsWith('/profissional') || 
                            url.startsWith('/admin');
    const isAuthRoute = url.startsWith('/login') || 
                        url.startsWith('/registro') || 
                        url.startsWith('/recuperar-senha');
    
    // Remover classes anteriores
    this.renderer.removeClass(document.body, 'dashboard-route');
    this.renderer.removeClass(document.body, 'auth-route');
    this.renderer.removeClass(document.body, 'public-route');
    
    // Adicionar classe apropriada
    if (isDashboardRoute) {
      this.renderer.addClass(document.body, 'dashboard-route');
    } else if (isAuthRoute) {
      this.renderer.addClass(document.body, 'auth-route');
    } else {
      this.renderer.addClass(document.body, 'public-route');
    }
  }
}
